/**
 * Mobile layout
 * On mobile we dictate the order, however on desktop
 * we use CSS grid to position the elements.
 */

.templatedFooter {
  display: flex;
  background-color: var(--colors-background);
  color: var(--colors-text-main);
  flex-direction: column;
  padding: 24px var(--page-margin);
}

.templatedFooter__layout {
  display: flex;
  flex-direction: column;
  gap: 64px;
  margin-left: auto;
  margin-right: auto;
  max-width: var(--page-max-width);
  width: 100%;
}

.ctaSection {
  order: var(--cta-section-order);
}

.ctaButton {
  width: 100%;
}

.socialLinksSection {
  order: var(--social-links-section-order);
}

.linksColumn {
  order: var(--links-column-order);
  margin-bottom: -8px;
}

.linksColumn ~ .linksColumn {
  margin-bottom: 0px;
}

.logoSection {
  order: var(--logo-section-order);
}

.textContent {
  order: var(--text-content-order);
  margin-top: 0px;
}

/* Tablet + desktop layout */
@media all and (--reefer-media-tablet-min) {
  .templatedFooter {
    padding-left: var(--page-margin-desktop);
    padding-right: var(--page-margin-desktop);
    padding-bottom: 64px;
  }

  .templatedFooter__layout {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 12px;
  }

  .logoSection {
    grid-column: 1 / span 3;
    grid-row: 1;
    order: unset;
  }

  .templatedFooter.alignRight .logoSection {
    grid-column: 9 / span 3;
  }

  .ctaSection {
    grid-column: 1 / span 4;
    grid-row: 1;
    order: unset;
  }

  .logoSection ~ .ctaSection {
    grid-row: 2;
  }

  .ctaButton {
    width: fit-content;
  }

  .templatedFooter.alignRight .ctaSection {
    grid-column: 9 / span 4;
  }

  .socialLinksSection {
    grid-column: 1 / span 4;
    grid-row: 2;
    order: unset;
  }

  .logoSection ~ .ctaSection ~ .socialLinksSection {
    grid-row: 3;
  }

  .templatedFooter.alignRight .socialLinksSection {
    grid-column: 9 / span 4;
  }

  .linksColumn {
    /**
     * For left align menus, we align the link columns on the right side of the footer.
     * Each links column spans 2 of the 12 grid columns.
     * If there are three link columns, the grid columns need to be at 7, 9 and 11
     * If there are two link columns, the grid columns need to be at 9 and 11
     * If there is only one link column, the grid column needs to be 11
     *
     * Formula: 5 + 2 * (index + 1 + (MAX_LINK_COLUMNS - numLinkColumns))
     * MAX_LINK_COLUMNS = 3
     * Simplified: 5 + 2 * index + 8 - 2 * count
     *             = 13 + 2 * index - 2 * count
     */
    grid-column: calc(
        13 + 2 * var(--links-column-index) - 2 * var(--links-column-count)
      ) /
      span 2;
    grid-row: 1 / span 2;
    margin-bottom: 0px;
    order: unset;
  }

  .templatedFooter.alignRight .linksColumn {
    /* For align_right: position from the left starting at column 1 */
    grid-column: calc(1 + 2 * var(--links-column-index)) / span 2;
  }

  .textContent {
    grid-column: 1 / -1;
    grid-row: 3;
    margin-top: 40px;
    order: unset;
  }

  .logoSection ~ .ctaSection ~ .socialLinksSection ~ .textContent {
    grid-row: 4;
  }
}

/* Desktop layout */
@media all and (--reefer-media-desktop-sm-min) {
  .templatedFooter {
    padding: 64px;
  }

  .templatedFooter__layout {
    gap: 40px;
  }
}
